import { createTheme } from '@material-ui/core';

let theme = createTheme({
  breakpoints: { values: { xs: 0, sm: 600, md: 1130, lg: 1240, xl: 1940 } },
})
theme = createTheme( theme, {
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius:"0px !important",
          minHeight:"55px",
          fontFamily: 'Questrial !important',
          fontSize:"16px",
          textTransform:"unset",
          [theme.breakpoints.up('sm')]: {
            minHeight:"60px",
            fontSize:"17px",
          },
          "&:hover": {
            backgroundColor: "rgba(0,0,0,0.8)",
          },
        },
      },
    },
    MuiSlider : {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
        },
        markLabel : {
          fontFamily: 'Questrial !important',
        },
      },
    },
    MuiButtonBase : {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
          borderRadius:"0px !important",
          background:"white",
          height:'50px',
          color:"black",
          "fieldset" : {
            border:"1px solid black",
          },
          [theme.breakpoints.up('sm')]: {
            height:'60px',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
          color:"rgba(10, 10, 11, 0.5) !important",
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
        },
      },
    },
    MuiPaper : {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
          borderRadius:0,
        },
      },
    },
    MuiMenuItem : {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
          paddingLeft:"24px",
          paddingRight:"24px",
        },
      },
    },
    MuiFormHelperText:{
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
        },
      },
    },
  },
  palette: {
    background: {
      default: '#ffffff',
      paper: '#ffffff',
      grey: '#FAF8F6',
    },
    primary: {
      contrastText: '#ffffff',
      main: '#000000'
    },
    text: {
      primary: '#565656',
      secondary: '#0A0A0B',
      black: '#000000',
      blackTitle:"#23272E",
      subTitle:"rgba(10, 10, 11, 0.75)",
    }
  },
  shadows: [
    'none',
    '0 0 0 1px rgba(63,63,68,0.05), 0 1px 2px 0 rgba(63,63,68,0.15)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 2px 2px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 8px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 5px 8px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 6px 12px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 7px 12px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 6px 16px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 7px 16px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 8px 18px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 9px 18px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 10px 20px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 11px 20px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 12px 22px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 13px 22px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 14px 24px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 16px 28px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 18px 30px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 20px 32px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 22px 34px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 24px 36px -8px rgba(0,0,0,0.25)'
  ],
  typography: {
    fontFamily: 'Questrial',
    allVariants: {
      fontFamily: 'Questrial',
    },
    h1: {
      fontSize: 35,
    },
    h2: {
      fontSize: "26px",
      [theme.breakpoints.up('sm')]: {
        fontSize: '46px',
      },
    },
    h3: {
      fontSize: 24,
    },
    h4: {
      fontSize: 20,
    },
    h5: {
      fontSize: 16,
    },
    h6: {
      fontSize: 14,
    },
  }
});

export default theme;
